import { defineStore } from "pinia"

export const useUserInfoStore = defineStore("userInfo", () => {
	const userInfo: Ref<UserInfo | null> = ref(null)

	const setUserInfo = (data: MaybeRefOrGetter<UserInfo | null>) => {
		userInfo.value = toValue(data)
	}

	return {
		userInfo,
		setUserInfo
	}
})
